import {
  parseBodyMapFromData,
  parseContentMapFromData,
  parseMaterialMapFromData,
} from "../../utilization/CatchtivityUtilization";
import ActivityBodyContent from "./body-contents/ActivityBodyContent";
import MCSAActivityMaterialContent from "./material-contents/MCSAActivityMaterialContent";
import { IMCSAActivityProps } from "../../properties/ActivityProperties";
import ActivitySolveLayout from "./ActivitySolveLayout";

const MCSAActivityContent = ({
  answerMap,
  data,
  canAnswerQuestion,
  changeAnswer,
  isPreview,
  showCorrectAnswer,
  isFullScreen,
  passage,
  revealMarkers,
}: IMCSAActivityProps) => {
  const contentMap = parseContentMapFromData(data);
  const MCSABodyMap = parseBodyMapFromData(data, "MCSA");
  const MCSAMaterialMap = parseMaterialMapFromData(data, "MCSA");

  const handleMCSAAnswerOnChange = (
    answerMap: any,
    key: any,
    value: string
  ) => {
    if (isPreview) return;
    answerMap[key] = value;
    changeAnswer(answerMap);
  };

  return (
    <ActivitySolveLayout
      variant="split"
      // Safe to pin: picking an option never changes the pane's height.
      paneFit
      isFullScreen={isFullScreen}
      passage={passage}
      body={<ActivityBodyContent bodyMap={MCSABodyMap} templateType="MCSA" />}
      interaction={
        <MCSAActivityMaterialContent
          uniqueValue={JSON.stringify(data.contentMap)}
          answerMap={answerMap}
          materialMap={MCSAMaterialMap}
          contentMap={contentMap}
          checkCanAnswerQuestion={canAnswerQuestion}
          onChange={handleMCSAAnswerOnChange}
          showCorrectAnswer={showCorrectAnswer}
          isPreview={isPreview}
          revealMarkers={revealMarkers}
        />
      }
    />
  );
};

export default MCSAActivityContent;
